import { TableChoiceGroupFilter } from 'uikit';

import * as R from 'ramda';
import { useMemo } from 'react';

export const useBimContractStructureFilters = () =>
    useMemo(
        () => [
            {
                id: 'hasGuaranteedVolume',
                name: 'Гарантированный объем: ',
                field: 'hasGuaranteedVolume',
                filterer: R.T,
                component: {
                    name: TableChoiceGroupFilter,
                    props: {
                        items: [
                            {
                                name: 'Да',
                                value: 'Да',
                            },
                            { name: 'Нет', value: 'Нет' },
                        ],
                    },
                },
            },
        ],
        [],
    );
